module.exports = __webpack_public_path__ + "static/media/Fig2.1b66636f.jpg";